module.exports = __webpack_public_path__ + "images/human-robot-leads.png";